<template>
  <div class="hello">
    <div style="height: 150px;">
      <img class="logoimg" src="https://classoss.zhuokairui.cn/img/dingming/imgs/contact/logo1.png" alt="">
    </div>
    <el-menu
      background-color="#1e70ca"
      active-text-color="#8ddef5"
      class="show-sj"
      :default-active="$route.path"
      router
    >
      <el-menu-item>
        <img style="width: 46px;height: auto;" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/logo.png" alt="" />
      </el-menu-item>
      <el-menu-item index="/index">
        <div>
          <span slot="title">公司简介</span>
        </div>
      </el-menu-item>
      <el-menu-item index="/assistant">
        <span slot="title">组织架构</span>
      </el-menu-item>
      <el-menu-item index="/security">
        <span slot="title">公司资质证书</span>
      </el-menu-item>
      <el-menu-item index="/classroom">
        <span slot="title">公司荣誉</span>
      </el-menu-item>
      <el-menu-item index="/propaganda">
        <span slot="title">项目成果</span>
      </el-menu-item>
      <el-menu-item index="/culture">
        <span slot="title">企业文化</span>
      </el-menu-item>
      <el-menu-item index="/contact">
        <span slot="title">联系我们</span>
      </el-menu-item>
    </el-menu>
    <div class="flex">
      <el-menu
        background-color="#1e70ca"
        active-text-color="#8ddef5"
        class="flex-left hidden-md-and-down"
        :default-active="$route.path"
        router
      >
        <div class="imgflex">
          <img style="width: 46px;height: auto;" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/logo.png" alt="" />
<!--          <div>中恺鼎铭</div>-->
        </div>
        <el-menu-item index="/index">
          <div>
            <span slot="title">公司简介</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/assistant">
          <span slot="title">组织架构</span>
        </el-menu-item>
        <el-menu-item index="/security">
          <span slot="title">公司资质证书</span>
        </el-menu-item>
        <el-menu-item index="/classroom">
          <span slot="title">公司荣誉</span>
        </el-menu-item>
        <el-menu-item index="/propaganda">
          <span slot="title">项目成果</span>
        </el-menu-item>
        <el-menu-item index="/culture">
          <span slot="title">企业文化</span>
        </el-menu-item>
        <el-menu-item index="/contact">
          <span slot="title">联系我们</span>
        </el-menu-item>
      </el-menu>
      <div class="flex-right">
        <router-view/>
        <div class="footer">
          <p>中恺鼎铭建设集团有限公司</p>
          <p>dingming.vip</p>
          <p><a href="https://beian.miit.gov.cn/" style="text-decoration: none">琼ICP备17002470号-4</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  body{margin: 0px;}
</style>
<style scoped>
  .footer{text-align: center;padding: 20px 0px;}
  .flex{display: flex;justify-content: center;}
  .el-menu{border-right:none;}
  ul.flex-left{width: 160px;height: 100vh;background-color: rgb(141, 190, 234);position: sticky;top: 0px;}
  ul li{color: white;}
  ul li.is-active{background-color: rgb(24, 90, 162)!important;}
  .flex-right{margin: 10px;width: 1140px;}
  .imgflex{display: flex;align-items: center;color: white;padding-top: 10px;padding-left: 20px;}
  .logoimg{object-fit: cover;width: 100%;height: 150px;margin: 0px;}
  .show-sj{display: none;}
  @media screen and (max-width: 1199px) {
      .show-sj{display: block;display:flex;overflow-x: auto;overflow-y: hidden;}
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue